import { mutator } from 'satcheljs';
import { storeContextualMRUSuggestionsOnItemAction } from '../actions/internalActions';
import getMRUAttachmentStore from '../store/mruAttachmentStore';

export default mutator(storeContextualMRUSuggestionsOnItemAction, actionMessage => {
    getMRUAttachmentStore().contextualAttachmentSuggestions.set(actionMessage.referenceItemId, {
        attachments: actionMessage.contextualSuggestions,
        traceId: actionMessage.traceId,
    });
});
